const HOST_ID = 'helply-agent-root-container';
const STYLE_ID = 'covidence-helply-trigger-a11y';
const DESKTOP_QUERY = '(min-width: 769px)';

function isDesktopViewport(): boolean {
  return (
    (window.matchMedia?.(DESKTOP_QUERY)?.matches ?? false) ||
    window.innerWidth >= 769
  );
}

function getShadowRoot(): ShadowRoot | null {
  const host = document.getElementById(HOST_ID) as HTMLElement | null;
  return host?.shadowRoot ?? null;
}

function addStyleToButton(root: ShadowRoot): void {
  if (root.querySelector(`#${STYLE_ID}`)) return;

  const styleEl = document.createElement('style');
  styleEl.id = STYLE_ID;
  styleEl.textContent = `
    [part="helply-agent-trigger"] {
      box-shadow: 0 0 10px #00000020 !important;
    }

    [part="helply-agent-trigger"]:focus,
    [part="helply-agent-trigger"]:focus-visible {
      outline: 2px solid #2F81FF !important;
      outline-offset: 2px !important;
    }
  `;
  root.appendChild(styleEl);
}

function ensureStylesIsApplied(): boolean {
  const root = getShadowRoot();
  if (!root) return false;

  addStyleToButton(root);
  return true;
}

export function applyHelplyButtonTriggerStyles() {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  if (!isDesktopViewport()) return () => {};

  let docObserver: MutationObserver | null = null;
  let shadowObserver: MutationObserver | null = null;
  let intervalId: number | null = null;
  let stopped = false;

  const stopAll = () => {
    if (docObserver) docObserver.disconnect();
    if (shadowObserver) shadowObserver.disconnect();
    if (intervalId) window.clearInterval(intervalId);
    docObserver = null;
    shadowObserver = null;
    intervalId = null;
  };

  const enableBubbleButtonObserver = () => {
    const root = getShadowRoot();
    if (!root || shadowObserver) return;

    shadowObserver = new MutationObserver(() => {
      if (!stopped) ensureStylesIsApplied();
    });

    shadowObserver.observe(root, { childList: true, subtree: true });
  };

  const tryToAddStyle = () => {
    if (stopped) return;

    if (ensureStylesIsApplied()) {
      enableBubbleButtonObserver();

      if (docObserver) {
        docObserver.disconnect();
        docObserver = null;
      }
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    }
  };

  tryToAddStyle();

  docObserver = new MutationObserver(tryToAddStyle);
  docObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  intervalId = window.setInterval(tryToAddStyle, 250);

  return () => {
    stopped = true;
    stopAll();
  };
}
